import { TimeSignalAnalytic } from 'graphql/types';

const clientColorSet = ['#31383d', '#8832a1', '#d83559', '#563aa8', '#e54938'];
const projectColorSet = ['#308cea', '#fee653', '#364ba6', '#f1592e', '#2f887d'];
const taskColorSet = ['#cad44d', '#59717e', '#949494', '#309fec', '#f5912f'];

export const labelColorset = (labelType: string): string[] | undefined => {
  if (labelType === 'CLIENT') return clientColorSet;
  else if (labelType === 'PROJECT') return projectColorSet;
  else return taskColorSet;
};

export type PieChartData = {
  x: string;
  y: number;
  color: string;
  name: string;
  symbol: { fill: string };
}[];

export const transformLabelData = (
  data: TimeSignalAnalytic | undefined,
  labelType: string
): PieChartData => {
  const colorSet = labelColorset(labelType) || [];
  const getChartColor = (index: number): string => {
    const colorSetLength = colorSet.length;
    if (index > colorSetLength - 1) {
      return colorSet[(index % colorSetLength) - 1];
    } else return colorSet[index];
  };

  const dataset = data?.dimensions.map((item, index) => {
    const value = {
      x: item.name,
      y: data.metrics[index].totalDuration,
      name: item.name
    };
    return value;
  });
  dataset?.sort((a, b) => a.name.localeCompare(b.name));
  const datasetWithColor = dataset?.map((data, i) => {
    const values = {
      x: data.x,
      y: data.y,
      color: getChartColor(i),
      name: data.name,
      symbol: { fill: getChartColor(i) }
    };
    return values;
  });
  return datasetWithColor || [];
};
